import { RouteObject } from 'react-router';

import { CategoryDetails } from './CategoryDetails';
import { CategoryList } from './CategoryList';
import { IngredientDetails } from './IngredientDetails';
import { IngredientList } from './IngredientList';
import { PackagingFormatDetails } from './PackagingFormatDetails';
import { PackagingFormatList } from './PackagingFormatList';
import { PourFormatDetails } from './PourFormatDetails';
import { PourFormatList } from './PourFormatList';
import { PourTypeDetails } from './PourTypeDetails';
import { PourTypeList } from './PourTypeList';
import { PriceTierDetails } from './PriceTierDetails';
import { PriceTierList } from './PriceTierList';
import { ServingContainerDetails } from './ServingContainerDetails';
import { ServingContainerList } from './ServingContainerList';
import { SubstitutionDetails } from './SubstitutionDetails';
import { SubstitutionList } from './SubstitutionList';

export const CORE_ROUTES: RouteObject[] = [
    { path: 'price-tiers', Component: PriceTierList },
    { path: 'price-tiers/:id', Component: PriceTierDetails },
    { path: 'categories', Component: CategoryList },
    { path: 'categories/:id', Component: CategoryDetails },
    { path: 'ingredients', Component: IngredientList },
    { path: 'ingredients/:id', Component: IngredientDetails },
    { path: 'substitutions', Component: SubstitutionList },
    { path: 'substitutions/:id', Component: SubstitutionDetails },
    { path: 'pour-types', Component: PourTypeList },
    { path: 'pour-types/:id', Component: PourTypeDetails },
    { path: 'pour-formats', Component: PourFormatList },
    { path: 'pour-formats/:id', Component: PourFormatDetails },
    { path: 'packaging-formats', Component: PackagingFormatList },
    { path: 'packaging-formats/:id', Component: PackagingFormatDetails },
    { path: 'serving-containers', Component: ServingContainerList },
    { path: 'serving-containers/:id', Component: ServingContainerDetails },
];
